module.exports = __webpack_public_path__ + "static/media/team-building-icon.e82713e2.svg";